import React, { memo } from 'react';
import DeploymentFrequencyChart from '../charts/DeploymentFrequencyChart';

/**
 * Card wrapper for the Deployment Frequency DORA chart.
 */
const DeploymentFrequencyDoraCard = memo(function DeploymentFrequencyDoraCard({
  loading,
  noData,
  dates = [],
  counts = [],
  windowDays,
  period,
  chartType,
  onPeriodChange,
  onChartTypeChange,
  emptyMessage = 'No deployment frequency data in this window.',
}: any) {
  const hasChartData =
    Array.isArray(dates) &&
    dates.length > 0 &&
    Array.isArray(counts) &&
    counts.length === dates.length;

  return (
    <div className="card-mdl-static p-4 min-w-0">
      {noData && !loading ? (
        <p className="text-sm text-slate-400">{emptyMessage}</p>
      ) : (
        <DeploymentFrequencyChart
          dates={hasChartData ? dates : []}
          counts={hasChartData ? counts : []}
          windowDays={windowDays}
          period={period}
          chartType={chartType}
          onPeriodChange={onPeriodChange}
          onChartTypeChange={onChartTypeChange}
          loading={loading}
        />
      )}
    </div>
  );
});

export default DeploymentFrequencyDoraCard;
